"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentGetMetadataFormEnrollmentTypeEnum = exports.AttachmentGetMetadataFormToJSON = exports.AttachmentGetMetadataFormFromJSONTyped = exports.AttachmentGetMetadataFormFromJSON = void 0;
const runtime_1 = require("../runtime");
function AttachmentGetMetadataFormFromJSON(json) {
    return AttachmentGetMetadataFormFromJSONTyped(json, false);
}
exports.AttachmentGetMetadataFormFromJSON = AttachmentGetMetadataFormFromJSON;
function AttachmentGetMetadataFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'enrollmentType': !runtime_1.exists(json, 'enrollmentType') ? undefined : json['enrollmentType'],
    };
}
exports.AttachmentGetMetadataFormFromJSONTyped = AttachmentGetMetadataFormFromJSONTyped;
function AttachmentGetMetadataFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'enrollmentType': value.enrollmentType,
    };
}
exports.AttachmentGetMetadataFormToJSON = AttachmentGetMetadataFormToJSON;
/**
* @export
* @enum {string}
*/
var AttachmentGetMetadataFormEnrollmentTypeEnum;
(function (AttachmentGetMetadataFormEnrollmentTypeEnum) {
    AttachmentGetMetadataFormEnrollmentTypeEnum["NEWENROLLMENT"] = "NEW_ENROLLMENT";
    AttachmentGetMetadataFormEnrollmentTypeEnum["RENEWAL"] = "RENEWAL";
})(AttachmentGetMetadataFormEnrollmentTypeEnum = exports.AttachmentGetMetadataFormEnrollmentTypeEnum || (exports.AttachmentGetMetadataFormEnrollmentTypeEnum = {}));
//# sourceMappingURL=AttachmentGetMetadataForm.js.map